import React, {useEffect, useRef, useState} from 'react';
import logo from "../logo.svg";
import {useDispatch, useSelector} from "react-redux";

import i18n from "../resources/i18nSetup";
import {ValidationRule} from "../helpers/validationRule";
import {UseValidationForm} from "./useValidationForm";
import {Box, Button, CircularProgress, Grid} from "@mui/material";
import Loading from "../helpers/loading";
import {RESPONSE_STATUS} from "../constants";
import {
  setCSRFToken,
  updateIndexPage,
  updateVoucherNumber,
  VoucherValidation
} from "../redux/reducers/voucherPortalFormReducer";
import {create} from "@mui/material/styles/createTransitions";
import axios from "axios";
function TicketNumber(props) {
  const mountedRef = useRef();
  const validtionRef = useRef();
  let initialValues = {};
  const dispatch = useDispatch();
  const [validations, setValidations] = useState({
    ticketNumber: {
      required: ValidationRule.required,
      pattern: ValidationRule.digits,
    }
  });
  const [isValidTicket, setIsValidTicket] = useState(undefined);
  const  csrfTokenStatus = useSelector((state) =>
    state.VoucherPortalFormReducer.csrfToken.status
  );
  const  csrfTokenResponse = useSelector((state) =>
    state.VoucherPortalFormReducer.csrfToken
  );

  const  classes = useSelector((state) =>
    state.VoucherPortalFormReducer.classes
  );

  const isUpdateToken = useSelector((state) =>
    state.VoucherPortalFormReducer.isUpdateToken
  );
  const validationStatus = useSelector((state) =>
    state.VoucherPortalFormReducer.voucherValidation.status
  );

  const VoucherValidationResponse = useSelector((state) =>
    state.VoucherPortalFormReducer.voucherValidation.response
  );

  const submitTicketDetails = () => {
    if( !localStorage.getItem('csrf_token') && !mountedRef.current ){
      updateToken()
    }
    else if (localStorage.getItem('csrf_token')){
      validtionRef.current = true
      let formData = getFormData();
      dispatch(VoucherValidation({voucher_no: formData.ticketNumber}))
    }
  }

  const updateToken = () => {
    mountedRef.current = true;
    let secretString = process.env.REACT_APP_SECRET_STRING;
    dispatch(setCSRFToken({
      secret: secretString
    }))
  }

  useEffect(() => {
  if(csrfTokenStatus == RESPONSE_STATUS.Succeeded &&   mountedRef.current){
    submitTicketDetails()
  }
  else if (csrfTokenStatus == RESPONSE_STATUS.Error){
    mountedRef.current = null
    window.alert(csrfTokenResponse.response.message)
  }
  }, [csrfTokenStatus]);

  useEffect(() => {
    if(isUpdateToken == true) {
      mountedRef.current = null
      submitTicketDetails()
    }
  }, [isUpdateToken]);


  useEffect(() => {
    if (validationStatus == RESPONSE_STATUS.Succeeded && validtionRef.current){
        if(VoucherValidationResponse.is_valid){
          let formData = getFormData();
          dispatch(updateVoucherNumber(formData.ticketNumber))
         if (VoucherValidationResponse.tickets_issued){
           dispatch(updateIndexPage(2))
         }
         else{
           dispatch(updateIndexPage(1))
         }
       }
       else{
         setIsValidTicket(false)
       }
    }
  }, [validationStatus]);



  const getFormData = () => {
    return {
      ticketNumber: data.ticketNumber,
    }
  }
  const handleChangeTicketNumber = (key, sanitizeFn) => (
    e,
  ) => {

    setIsValidTicket(true)
    handleChange(key, sanitizeFn)(e)
  };
  const {handleSubmit, handleChange, data, errors} = UseValidationForm({
    onSubmit: submitTicketDetails,
    validations: validations,
    initialValues: initialValues
  });



  return (
    <Grid item xs={12}>
          <form  noValidate onSubmit={handleSubmit}  >
            <Grid container direction={"row"} spacing={1}>
              <Grid item xs={12}>
                <h2 class={classes && classes.h2_classes}>{i18n.t('ticketNumberScreenTitle')}</h2>
                <p  class={classes && classes.p_classes.regular}>{i18n.t('ticketNumberSecondTitle')}</p>
              </Grid>
              <Grid item xs={6}>
                <Grid container direction={"column"} sx={{mt:1,mb:1}} spacing={0}>
                 <label class={classes && classes.label_classes}>
                   {i18n.t('ticketNumber')}
                 </label>
                 <input class={classes && classes.input_classes.regular}
                      type="text"
                      name="ticketNumber"

                      value={data.ticketNumber}

                      onChange={handleChangeTicketNumber("ticketNumber")}
                      onBlur={handleChangeTicketNumber("ticketNumber")}
                    />
                    {(errors["ticketNumber"] || (isValidTicket != undefined && !isValidTicket)) &&
                      <p  class={classes && classes.p_classes.error} >{errors["ticketNumber"]?i18n.t(errors["ticketNumber"]):i18n.t("notValidTicketError")}</p>
                    }
                </Grid>
              </Grid>
          <Grid container alignItems={"flex-end"} justify="flex-end" item
                    sm={12}>
            {validationStatus === RESPONSE_STATUS.Loading || csrfTokenStatus === RESPONSE_STATUS.Loading ? (
              <Box sx={{height: '100%', display: "flex", alignItems: "center", justifyContent: "center"}}>
                <CircularProgress color="inherit"/>
              </Box>
            ) : <input class={classes && classes.input_classes.submit} type="submit" value={i18n.t("continueButton")}/>
            }
              </Grid>
            </Grid>
          </form>
    </Grid>
  );
}

export default TicketNumber
